import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import {connect} from 'pwa-helpers';
import store from '../../store';
import {
	selectIomoDesign,
	selectIomoPoleDiameter,
	selectIomoPoleDiameterIsSatisfied,
	selectIomoNumberOfHeads,
	selectIomoNumberOfHeadsIsSatisfied,
	selectIomoPoleHeight,
	selectIomoPoleHeightIsSatisfied,
	selectIomoBase,
	selectIomoBaseIsSatisfied,
	selectIomoSeparateBuriedBase,
	selectIomoSeparateBuriedBaseIsSatisfied,
	selectIomoMaxNumberOfHeads,
	selectIomoSecondDoor,
	selectIomoSecondDoorIsSatisfied,
	selectIomoBuriedBaseSize,
	selectIomoBuriedBaseSizeIsSatisfied, selectIomoPoleShape, selectIomoPoleShapeIsSatisfied
} from '../iomoSelectors';
import {
	iomoBaseOptions,
	iomoBuriedBaseSizeOptions,
	iomoNumberOfHeadsOptions,
	iomoSecondDoorOptions,
	iomoSeparateBuriedBaseOptions,
	iomoPoleHeightOptions,
	iomoPoleDiameterOptions,
	iomoPoleShapeOptions,
} from '../iomoModel';

@customElement('iomo-general-design-settings')
export class IomoGeneralDesignSettings extends connect(store)(LitElement) {

	static styles = [
		css`
			:host {
				display: flex;
				break-inside: avoid;
				flex-flow: column;
				place-content: flex-start;
				gap: var(--small-padding);
			}

			.box {
				background-color: var(--color-widget-background);
				padding: 12px;
				display: flex;
				break-inside: avoid;
				flex-flow: column;
				place-content: flex-start;
				gap: var(--large-space);
			}
		`
	];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.lang = state.status.lang;
		this.design = selectIomoDesign(state);
		this.poleHeightOptions = iomoPoleHeightOptions;
		this.poleDiameterOptions = iomoPoleDiameterOptions;
		this.poleShapeOptions = iomoPoleShapeOptions;
	}

	housingSizeCanBeSelected(state, id) {
		return (id !== 'custom');
	}
	numberOfHeadsCanBeSelected(state, id) {
		const max = selectIomoMaxNumberOfHeads(state);
		return (parseInt(id, 10) <= max);
	}
	poleDiameterCanBeSelected(state, id) {
		const poleHeight = selectIomoPoleHeight(state);
		const poleShape = selectIomoPoleShape(state);
		if (id === '114') {
			return poleShape === 'cylindrical';
		}
		if (id === '140') {
			return poleShape === 'cylindrical';
		}
		if (id === '159') {
			return poleShape === 'cylindrical';
		}
		if (id === '76') {
			return poleShape === 'conical' && (poleHeight >= 4 && poleHeight <= 10);
		}
		if (id === '89') {
			return poleShape === 'conical' && (poleHeight >= 9 && poleHeight <= 10);
		}
		return false;
	}
	poleShapeCanBeSelected(state, id) {
		const poleHeight = selectIomoPoleHeight(state);
		if (poleHeight >= 4 && poleHeight <= 9) {
			return id === 'cylindrical' || id === 'conical';
		}
		if (poleHeight >= 4 && poleHeight <= 10) {
			return id === 'cylindrical' || id === 'conical';
		}
		return false;
	}
	poleHeightCanBeSelected(state, id) {
		const poleShape = selectIomoPoleShape(state);
		if (poleShape === 'cylindrical') {
			return id === '4' || id === '5' || id === '6' || id === '7' || id === '8' || id === '9';
		}
		if (poleShape === 'conical') {
			return id === '4' || id === '5' || id === '6' || id === '7' || id === '8' || id === '9' || id === '10';
		}
		return false;
	}
	baseCanBeSelected(state, id) {
		const poleHeight = selectIomoPoleHeight(state);
		const design = selectIomoDesign(state);
		return (id === 'buriedbase') ||
			(id === 'FlangePlateDE') ||
			(id === 'FlangePlateFRsmall' && poleHeight <= 7) ||
			(id === 'FlangePlateFR' && (poleHeight > 7));
	}
	separateBaseCanBeSelected(state, id) {
		const poleHeight = selectIomoPoleHeight(state);
		const design = selectIomoDesign(state);
		const base = selectIomoBase(state);
		return (id === 'none') ||
			(id === 'separateBuriedBase' && base === 'FlangePlateDE');
	}
	secondDoorCanBeSelected(state, id) {
		const design = selectIomoDesign(state);
		return (id === 'none') || (id === 'secondDoor');
	}
	buriedBaseSizeCanBeSelected(state, id) {
		const base = selectIomoBase(state);
		return (base === 'buriedbase');
	}
	render() {
		return html`
			<div class="box">
				<list-select
					.title=${{
						de: 'Masthöhe',
						en: 'Pole Height',
						fr: 'hauteur du mât'
					}}
					.options=${this.poleHeightOptions}
					action='iomo/setPoleHeight'
					.selected=${selectIomoPoleHeight}
					.canBeSelected=${this.poleHeightCanBeSelected}
					.isSatisfied=${selectIomoPoleHeightIsSatisfied}>
				</list-select>
				<list-select
					.title=${{
						de: 'Mast Form',
						en: 'Pole Shape',
						fr: 'Pole Shape'
					}}
					.options=${this.poleShapeOptions}
					action='iomo/setPoleShape'
					.selected=${selectIomoPoleShape}
					.canBeSelected=${this.poleShapeCanBeSelected}
					.isSatisfied=${selectIomoPoleShapeIsSatisfied}>
				</list-select>
				<list-select
					.title=${{
						de: 'Mast Durchmesser',
						en: 'Pole Diameter',
						fr: 'Pole Diameter'
					}}
					.options=${this.poleDiameterOptions}
					action='iomo/setPoleDiameter'
					.selected=${selectIomoPoleDiameter}
					.canBeSelected=${this.poleDiameterCanBeSelected}
					.isSatisfied=${selectIomoPoleDiameterIsSatisfied}>
				</list-select>
				<list-select
					.title=${{
						de: 'Anzahl Leuchtenköpfe',
						en: 'Number of Luminairs',
						fr: 'nombre de luminaires'
					}}
					.options=${iomoNumberOfHeadsOptions}
					action='iomo/setNumberOfHeads'
					.selected=${selectIomoNumberOfHeads}
					.canBeSelected=${this.numberOfHeadsCanBeSelected}
					.isSatisfied=${selectIomoNumberOfHeadsIsSatisfied}>
				</list-select>
			</div>

			<div class="box">
				<iomo-layout-settings></iomo-layout-settings>
			</div>

			<div class="box">

				<list-select
					.title=${{de: 'Anbindung / Gründung', en: 'mounting / base', fr: 'mode de fixation'}}
					.options=${iomoBaseOptions}
					action='iomo/setBase'
					.selected=${selectIomoBase}
					.canBeSelected=${this.baseCanBeSelected}
					.isSatisfied=${selectIomoBaseIsSatisfied}>
				</list-select>
				<list-select
					.title=${{de: 'Erdstück Länge', en: 'Buried Base Size', fr: 'base à enfouissement longueur'}}
					.options=${iomoBuriedBaseSizeOptions}
					action='iomo/setBuriedBaseSize'
					.selected=${selectIomoBuriedBaseSize}
					.canBeSelected=${this.buriedBaseSizeCanBeSelected}
					.isSatisfied=${selectIomoBuriedBaseSizeIsSatisfied}>
				</list-select>
				<list-select
					.title=${{de: 'zusätzliche Gründung', en: 'additional mounting', fr: 'pièce de terre séparée'}}
					.options=${iomoSeparateBuriedBaseOptions}
					action='iomo/setSeparateBuriedBase'
					.selected=${selectIomoSeparateBuriedBase}
					.canBeSelected=${this.separateBaseCanBeSelected}
					.isSatisfied=${selectIomoSeparateBuriedBaseIsSatisfied}>
				</list-select>
				<list-select
					.title=${{de: '2. Masttür', en: '2. Pole Door', fr: '2. Porte de mât'}}
					.options=${iomoSecondDoorOptions}
					action='iomo/setSecondDoor'
					.selected=${selectIomoSecondDoor}
					.canBeSelected=${this.secondDoorCanBeSelected}
					.isSatisfied=${selectIomoSecondDoorIsSatisfied}>
				</list-select>


			</div>

		`;
	}
}
